import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  usuario: JwtResponse;
  usuarioRol: string = '';
  scrolled = false;
  menuOpen = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    if (this.usuario) {
      const img = this.usuario.user.img;
      if (img && img !== environment.candidatoDefault) {
        this.usuario.user.img = environment.baseArchivos + img;
      } else if (!img) {
        this.usuario.user.img = null;
      }
      this.usuarioRol = this.usuario.role;
    }
  }

  onAvatarError(event: Event): void {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  ngOnDestroy(): void {}

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 10;
  }

  toggleMenu(): void { this.menuOpen = !this.menuOpen; }
  closeMenu(): void  { this.menuOpen = false; }

  cerrarSesion(): void {
    this.authService.cerrarSesion();
    this.closeMenu();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = '/';
    } else {
      this.router.navigate(['/']);
    }
  }
}
